import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import { useColors } from '../../../packages/kiti/components/theme/_hooks/colors'
import { useUserEditAction, useUserRemoveAction } from './actions'

export const useUserFastActionsList = (item, opts = {}) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  const edit = useUserEditAction(item)
  const remove = useUserRemoveAction(item)

  return [
    ...appendIf(!hide.includes('edit') && edit.hasPermission, {
      label: t('edit'),
      icon: 'BsPencil',
      onClick: edit.click
    }),

    ...appendIf(!hide.includes('remove') && remove.hasPermission, {
      label: t('remove'),
      icon: 'BsTrash',
      color: colors.red,
      onClick: remove.click
    })
  ]
}
